import {useEffect, useRef} from "react";

import {usePopup} from "@layouts/popup/InfoPopup/PopupContext";
import {FillDataPopup} from "@popups/attentionPopups/FillDataPopup";
import {SuccessfulSavePopup} from "@popups/attentionPopups/SuccessfulSavePopup";
import CriteriaService from "@services/CriteriaService";
import {
  clearCreate,
  createCriteria,
  setError,
  setIsChanged,
  setTarget,
} from "@redux/slices/criteriaSlices/createSlice";
import {BackButton} from "@ui/buttons/BackButton";
import {EditTitle} from "@ui/forms/EditTitle";
import {BorderArticle} from "@ui/general/BorderArticle";
import {Spinner} from "@ui/general/Spinner";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";

import {CriteriaSectionsList} from "./components/CriteriaSectionsList";
import {
  hasCriteriaUserContent,
} from "./components/criteriaGridHelpers";
import styles from "./styles.module.scss";

export const CriteriaCreatePage = () => {
  const {openPopup} = usePopup();
  const {t} = useTranslation();
  const dispatch = useDispatch();

  const {isMobile} = useSelector((state) => state.common.settings);
  const {target, status} = useSelector((state) => state.criteria.create);

  const criteriaRef = useRef();

  const handleClickSave = async () => {
    if (!CriteriaService.isTargetValid(target)) {
      openPopup(<FillDataPopup />);
      return;
    }

    const resultAction = await dispatch(createCriteria({target}));

    if (createCriteria.fulfilled.match(resultAction)) {
      openPopup(<SuccessfulSavePopup title={t("popup.save_data.criteria")} />);
      dispatch(clearCreate());
    } else {
      dispatch(setError("Save error!"));
    }
  };

  useEffect(() => {
    dispatch(setIsChanged(hasCriteriaUserContent(target)));
  }, [target, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(clearCreate());
    };
  }, [dispatch]);

  useEffect(() => {
    if (criteriaRef.current && isMobile) {
      criteriaRef.current.scrollIntoView({behavior: "smooth"});
    }
  }, [isMobile]);

  return (
    <div
      ref={criteriaRef}
      className={styles.criteriaWrapper}
    >
      <BorderArticle>
        <div className={styles.criteria}>
          <BackButton />

          {status === "loading" ? (
            <Spinner
              width={80}
              height={80}
            />
          ) : (
            <div className={styles.criteriaContent}>
              <div className={styles.criteriaContentHeadWrapper}>
                <div className={styles.criteriaContentHead}>
                  <EditTitle
                    label={"criteria-name"}
                    value={target?.name}
                    placeholder={t("input.criteria_name_placeholder")}
                    onChange={(e) =>
                      dispatch(setTarget({...target, name: e.target.value}))
                    }
                    handleClickSave={handleClickSave}
                    disabledButton={false}
                  />
                </div>
              </div>

              <CriteriaSectionsList
                target={target}
                onChange={(nextTarget) => dispatch(setTarget(nextTarget))}
              />
            </div>
          )}
        </div>
      </BorderArticle>
    </div>
  );
};
